import { atom, useAtomValue } from "jotai";

export const publicFeatureFlagsLoadedAtom = atom(false);
export const authenticatedFeatureFlagsLoadedAtom = atom(false);

export function useFeatureFlagsState() {
  const arePublicFeatureFlagsLoaded = useAtomValue(publicFeatureFlagsLoadedAtom);
  const areAuthenticatedFeatureFlagsLoaded = useAtomValue(authenticatedFeatureFlagsLoadedAtom);

  return {
    arePublicFeatureFlagsLoaded,
    areAuthenticatedFeatureFlagsLoaded,
  };
}
